// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__1_vuL","row":"styles_row__2K4gb"};